"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { track } from "@/lib/analytics-client";
import { SOURCES } from "@/lib/analytics-events";
import { captureAttribution } from "@/lib/attribution";

export default function PageViewTracker(): null {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!pathname) return;
    captureAttribution();
    const referrer = typeof document !== "undefined" ? document.referrer : "";
    track(
      "page_view",
      SOURCES.autoPageView,
      {
        path: pathname,
        search: searchParams?.toString() || "",
        referrer,
      },
      pathname,
    );
  }, [pathname, searchParams]);

  return null;
}
